import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        appType: '',
        corporateID: 0,
        productId: 0,
        page: '',
        corporate: null,
    },
    mutations: {
        setAppType: function (state, appType) {
            state.appType = appType;
        },
        setCorporateID: function (state, corporateID) {
            state.corporateID = corporateID;
        },
        setPage: function (state, page) {
            state.page = page;
        },
        setProductId: function (state, productId) {
            state.productId = productId;
        },
        setCorporate: function (state, corporate) {
            state.corporate = corporate;
        }
    }
});
